import clone from 'just-clone'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  MathUtils,
  PerspectiveCamera,
  Scene,
  Vector2,
  WebGLRenderer,
} from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader'
import {
  HardwareType,
  MarkupType,
  MaterialAPIType,
  MaterialGroupType,
  MaterialType,
} from '../../api/appAPI'
import Cabinet from '../../classes/Cabinet'
import { ItemPropsType } from '../../classes/Item'
import LightGroup from '../../classes/LightGroup'
// import Cabinet from '../../classes/CabinetJs.js'
import { ConfigsType } from '../../config'
import { DefaultItems } from '../../data/DefaultItems'
import { actions as appActions } from '../../redux/appReducer'
import { StateType } from '../../redux/store'

const convertMaterial = (materials: MaterialType[]): MaterialAPIType[] => {
  const materialsProps = [] as MaterialAPIType[]

  for (const material of materials) {
    materialsProps.push({
      ...material,
      texture: material.texture.url,
    })
  }

  return materialsProps
}

interface IProps {
  // myWidth: .5 | .75 | 1

  windowSize: { width: number; height: number }
  // isSidebarOpen: boolean
  hardwaresList: HardwareType[]
  itemsPropsList: ItemPropsType[]
  markups: MarkupType[]
  // openItemsName: string[]
  // items: Item[]
  materials: MaterialType[]
  materialGroups: MaterialGroupType[]
  configs: ConfigsType
  // cabinetProps: CabinetProps
  // section: Section | undefined
  // doorType: DoorType
  // isFrontPanelsVisible: boolean
  // handleProps: HandlePropsType
  // viewSectionHeight: boolean
  // legProps: LegPropsType
  // splittedTop: boolean
  // doorVisualType: DoorVisualType

  setWindowSize(width: number, height: number): void
  // setSidebarHeight(value: number): void
  // setIsSidebarOpen(value: boolean): void
  // setItems(arr: Item[]): void
  // setItemsPropsList(arr: ItemPropsType[]): void
  // addItemsProps(arr: ItemPropsType[], forShelves?: boolean, shelfSectionNumber?: string): void
  // setSectionProps(prop: SectionProps): void
  // setSection(section: Section): void
  // setDivider(sectionName: string, divider: DividerPropsType): void
  // setDividers(arr: DividerPropsType[]): void
  // addDividers(arr: DividerPropsType[]): void
  // deleteDivider(dividerName: string): void
  // setSubsectionHeight(sectionName: string, height: number, prevHeight: number, locks: SectionLock[]): void
  // setSectionDoor(sectionNumber: number, door?: DoorPropsType): void
  // setSectionDrawer(sectionNumber: number, door?: DrawerPropsType): void
  // setDoors(arr: DoorPropsType[]): void
  // setDrawers(arr: DrawerPropsType[]): void
  // setHeight(prop: CabinetPropsValue): void
  // setIsFrontPanelsVisible(value: boolean): void
  // setViewSectionHeight(value: boolean): void
}

class DTool extends Component<IProps> {
  myDiv: any
  frameId: any

  scene = new Scene()
  camera = new PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    20000,
  )
  renderer = new WebGLRenderer({ antialias: true, preserveDrawingBuffer: true })

  //Controls
  orbit = new OrbitControls(this.camera, this.renderer.domElement)
  isOrbitPaused = false

  setOrbitControl = (value: boolean) => {
    if (value && this.isOrbitPaused) {
      this.orbit.reset()
      this.orbit.enabled = true
      this.isOrbitPaused = false
    } else if (!value) {
      this.orbit.saveState()
      this.orbit.enabled = false
      this.isOrbitPaused = true
    }
  }

  //Post Processing
  composer = new EffectComposer(this.renderer)
  outlinePass = new OutlinePass(
    new Vector2(window.innerWidth * 0.75, window.innerHeight - 88),
    this.scene,
    this.camera,
  )
  renderPass = new RenderPass(this.scene, this.camera)
  effectFXAA = new ShaderPass(FXAAShader)

  needRender = false
  setNeedRender = (value: boolean) => {
    this.needRender = value
  }

  cabinet = new Cabinet(
    'base',
    this.props.hardwaresList,
    convertMaterial(this.props.materials),
    this.props.materialGroups,
    this.props.markups,
    // @ts-ignore
    clone(DefaultItems) as ItemPropsType[],
    clone(DefaultItems) as ItemPropsType[],
    true,
    'vGroove',
    { on: true, type: 'standard' },
    [
      { number: 1, isLock: true },
      { number: 2, isLock: false },
    ],
    this.props.configs,
    () => {
      this.needRender = true
    },
  )

  componentDidMount() {
    window.addEventListener('resize', () => {
      // this.props.setWindowSize(window.innerWidth, window.innerHeight)
    })
    window.addEventListener('keydown', this.onKeyDown)

    this.orbit.addEventListener('change', () => {
      this.needRender = true
    })

    this.handleWindowResize(window.innerWidth, window.innerHeight)

    this.myDiv.appendChild(this.renderer.domElement)
    this.start()

    //Don't do it Again!!
    // @ts-ignore
    window.children = this.scene.children
    // @ts-ignore
    window.camera = this.camera
    // @ts-ignore
    window.pass = this.outlinePass
    // @ts-ignore
    window.scene = this.scene
    // window.light = this.light; window.THREE = THREE; window.renderer = this.renderer; window.renderScene = this.renderScene
    // @ts-ignore
    window.uuid = MathUtils.generateUUID
  }
  componentWillUnmount() {
    this.stop()
    this.myDiv.removeChild(this.renderer.domElement)
  }

  componentDidUpdate(prevProps: IProps) {
    if (prevProps.windowSize !== this.props.windowSize) {
      this.handleWindowResize(
        this.props.windowSize.width,
        this.props.windowSize.height,
      )
    }
    if (
      (prevProps.itemsPropsList !== this.props.itemsPropsList ||
        prevProps.hardwaresList !== this.props.hardwaresList ||
        prevProps.markups !== this.props.markups ||
        prevProps.materials !== this.props.materials ||
        prevProps.configs !== this.props.configs) &&
      this.props.markups.length > 0 &&
      this.props.hardwaresList.length > 0 &&
      this.props.materials.length > 0
    ) {
      // debugger
      // console.log(JSON.stringify(config))
      this.cabinet = new Cabinet(
        'base',
        this.props.hardwaresList,
        convertMaterial(this.props.materials),
        this.props.materialGroups,
        this.props.markups,
        // @ts-ignore
        clone(DefaultItems) as ItemPropsType[],
        clone(DefaultItems) as ItemPropsType[],
        true,
        'vGroove',
        {
          on: true,
          type: 'separateBase',
        },
        [
          { number: 1, isLock: true },
          { number: 2, isLock: false },
        ],
        this.props.configs,
        () => {
          this.needRender = true
        },
      )
      // console.log(JSON.stringify(this.props.hardwaresList))
      // console.log(JSON.stringify(convertMaterial(this.props.materials)))
      // console.log(JSON.stringify(this.props.materialGroups))
      // console.log(JSON.stringify(this.props.markups))
      // console.log(JSON.stringify(this.props.itemsPropsList))
      // console.log(JSON.stringify(configs))
      const index = this.scene.children.findIndex(
        (child) => child.name === this.cabinet.object.name,
      )
      if (index === -1) this.scene.add(this.cabinet.object)
      else this.scene.children[index] = this.cabinet.object
    }

    this.setNeedRender(true)
  }

  initOutline = () => {
    //Outline settings
    this.outlinePass.edgeGlow = 0.5
    // this.outlinePass.visibleEdgeColor.set('#ffffff') // default
    // this.outlinePass.pulsePeriod = 0 // default
    // this.outlinePass.edgeStrength = 3 //default

    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.outlinePass)
    this.composer.addPass(this.effectFXAA)
  }

  init = () => {
    // this.renderer.setPixelRatio(window.devicePixelRatio)

    // alert(window.devicePixelRatio + '_' + this.renderer.getPixelRatio())
    // this.renderer.setClearColor('#ff0000')
    // this.renderer.setClearColor('#fafafa')
    this.renderer.setClearColor('#f0efe1')
    // this.renderer.shadowMap.enabled = true
    // this.renderer.shadowMap.type = PCFSoftShadowMap

    // Light settings
    // this.light.position.set(0, 350, 0)
    // this.light2.position.set(1000, 1000, 0)
    // this.light2.castShadow = true
    // const lightGroup =
    new LightGroup(this.scene, 400, 400, 0.55)
    // const light = new PointLight(undefined, 1)
    // light.position.set(200, 50, 0)
    // this.scene.add(light)
    // this.scene.add(new PointLightHelper(light))

    // Controlers settings
    // this.orbit.screenSpacePanning = true

    this.camera.position.set(160, 160, 160)
    this.camera.lookAt(0, 0, 0)

    // const cube = new Mesh(
    //     new BoxGeometry(),
    //     new MeshNormalMaterial()
    // )

    // this.scene.add(cube)

    // console.log(this.props.hardwaresList, this.props.materials, this.props.markups, this.props.itemsPropsList)
    const index = this.scene.children.findIndex(
      (child) => child.name === this.cabinet.object.name,
    )
    if (index === -1) this.scene.add(this.cabinet.object)
    else this.scene.children[index] = this.cabinet.object
    // this.createCabinet(this.props.cabinetProps, this.props.itemsPropsList)
    // // this.visualizeItems(this.props.itemsPropsList)
    // this.outlinePass.selectedObjects = this.scene.children.filter(child => this.props.openItemsName.includes(child.name))

    this.initOutline()
    this.renderScene()
  }

  handleWindowResize = (winWidth: number, winHeight: number) => {
    const width = winWidth
    const height = winHeight - 48

    this.renderer.setSize(width, height)

    this.composer.setSize(width, height)
    this.effectFXAA.uniforms['resolution'].value.set(1 / width, 1 / height)
    this.outlinePass.resolution = new Vector2(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()

    this.renderScene()
  }

  onKeyDown = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.key === 's') {
      e.preventDefault()

      localStorage.setItem(
        'cabinet',
        JSON.stringify(this.cabinet.exportCabinet()),
      )
    } else if (e.key === 'l') {
      if (localStorage.getItem('normalCabinetInfo')) {
        this.cabinet.loadCabinet(
          JSON.parse(localStorage.getItem('normalCabinetInfo') || '').name,
        )
      }
    }
  }

  start = () => {
    this.init()
    if (!this.frameId) {
      this.frameId = requestAnimationFrame(this.animate)
    }
  }

  stop = () => {
    cancelAnimationFrame(this.frameId)
    window.removeEventListener('resize', () => {
      this.props.setWindowSize(window.innerWidth, window.innerHeight)
    })
    window.removeEventListener('keydown', this.onKeyDown)

    this.orbit.dispose()
  }

  animate = () => {
    if (this.needRender) {
      this.renderScene()
      this.needRender = false
    }
    // this.renderScene()
    this.frameId = window.requestAnimationFrame(this.animate)
  }

  renderScene = () => {
    this.renderer.render(this.scene, this.camera)
    this.composer.render()

    // @ts-ignore
    window.cabinet = this.cabinet
  }

  render() {
    return (
      <>
        <div
          className={'three'}
          style={{ position: 'relative' }}
          ref={(mount) => {
            this.myDiv = mount
          }}
        ></div>

        {/* <Box display='flex' style={{ columnGap: 15, position: 'absolute', right: 0, top: 48, margin: 17 }}>
                <Typography style={{ fontSize: 20 }}>${this.cabinet.getPrice()}</Typography>
            </Box> */}
      </>
    )
  }
}

const mapStateToProps = (state: StateType) => ({
  windowSize: state.appReducer.windowSize,
  // isSidebarOpen: state.appReducer.isSidebarOpen,
  itemsPropsList: state.itemReducer.itemsPropsList,
  hardwaresList: state.itemReducer.hardwaresList,
  markups: state.itemReducer.markups,
  // openItemsName: state.itemReducer.openItemsName,
  // items: state.itemReducer.items,
  materials: state.itemReducer.materials,
  materialGroups: state.itemReducer.materialGroups,
  configs: state.appReducer.configs,
  // cabinetProps: state.cabinetReducer.props,
  // section: state.cabinetReducer.section,
  // doorType: state.cabinetReducer.doorType,
  // isFrontPanelsVisible: state.cabinetReducer.isFrontPanelsVisible,
  // handleProps: state.cabinetReducer.handleProps,
  // viewSectionHeight: state.cabinetReducer.viewSectionHeight,
  // legProps: state.cabinetReducer.legProps,
  // splittedTop: state.cabinetReducer.splittedTop,
  // doorVisualType: state.cabinetReducer.doorVisualType,
})

export default connect(mapStateToProps, {
  // setSidebarHeight: appActions.setSidebarHeight,
  // setIsSidebarOpen: appActions.setIsSidebarOpen,
  setWindowSize: appActions.setWindowSize,
  // setItems: itemActions.setItems,
  // setItemsPropsList: itemActions.setItemsPropsList,
  // addItemsProps: itemActions.addItemsProps,
  // setSection: cabinetActions.setSection,
  // setSectionProps: cabinetActions.setSectionProps,
  // setDivider: cabinetActions.setDivider,
  // addDividers: cabinetActions.addDividers,
  // deleteDivider: cabinetActions.deleteDivider,
  // setDividers: cabinetActions.setDividers,
  // setSectionDoor: cabinetActions.setSectionDoor,
  // setSectionDrawer: cabinetActions.setSectionDrawer,
  // setDoors: cabinetActions.setDoors,
  // setDrawers: cabinetActions.setDrawers,
  // setHeight: cabinetActions.setHeight,
  // setIsFrontPanelsVisible: cabinetActions.setIsFrontPanelsVisible,
  // setViewSectionHeight: cabinetActions.setViewSectionHeight,
  // setSubsectionHeight,
})(DTool)

// export default () => <></>
